import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 1. 进入表单页面，且表单页面改动，state 为真
    // 2. 切换 tab ，或点击菜单，如果 state 为真则弹框
    // 3. 点击弹框的确认按钮，state 为假，不能切换菜单或切换 tab
    // 4. 点击弹框的取消按钮，state 还是真
    // 5. 表单如果成功提交，state 为假
    noSave: false
  },
  mutations: {
    SET_SAVE_STATUS: (state, status) => {
      state.noSave = status;
    }
  }
});
